import React, { useEffect, useState } from 'react';
import api from '../../../../Services/api';
import { Bar } from 'react-chartjs-2';
import { Doughnut } from 'react-chartjs-2';
import ProgressBar from 'react-bootstrap/ProgressBar'; // You can use this for the progress bar
import ChartDataLabels from 'chartjs-plugin-datalabels';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
// import ChartDataLabels from 'chartjs-plugin-datalabels';  // Import chartjs-plugin-datalabels
import { COLORS } from '../../../../Component/colors';
// Register Chart.js components
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js';
import { TroubleshootOutlined } from '@mui/icons-material';

ChartJS.register(
    Title,
    Tooltip,
    Legend,
    BarElement,
    CategoryScale,
    LinearScale,
    ChartDataLabels
);


const AvrgMonthlyCompliance = () => {
    let data1 = sessionStorage.getItem('user');
    let corporateData = JSON.parse(data1);
    let id = corporateData.id;

    const currentYear = new Date().getFullYear();
    const [yearlyData, setYearlyData] = useState(null);
    const [loading, setLoading] = useState(true);

    const [clients, setClients] = useState([]);
    const [selectedClient, setSelectedClient] = useState('');
    const [selectedYear, setSelectedYear] = useState(currentYear);
    const [selectedQuarter, setSelectedQuarter] = useState('Yearly'); // New state for selected quarter/half
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [errorSnackbarOpen, setErrorSnackbarOpen] = useState(false);
    const [snackbarErrorMessage, setSnackbarErrorMessage] = useState('');
    const [ data, setData ] = useState({ NoOfEmployees: 0, NoOfVendors: 0 })








    useEffect(() => {

        fetchVendors(selectedClient);



    }, [selectedClient]);

useEffect(() => {
    const empcount = async () => {
        try{
            const response = await api.Corporate.employeesandVendorCount(id);
            setData({ NoOfEmployees: response.data.NoOfEmployees, NoOfVendors: response.data.NoOfVendors });
        }catch(error){
            console.error('Error fetching data', error  );
        }
    }
    empcount();
}, [id])

  useEffect(() => {
    const timer = setTimeout(() => {
        getData()
    }, 1000); 
  
    return () => clearTimeout(timer); 
  }, [id,selectedYear]); 

    
        const getData = async () => {
            try {
                const response = await api.Corporate.avrgMonthlyComplianceClientWise(id, selectedYear);
                setYearlyData(response.data.data);
                setLoading(false)
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
     

    const fetchVendors = async () => {
        try {
            const response = await api.Corporate.getClientByCorporateId(id);

            if (response.status === 200) {
                setClients(response.data.data || []);
                console.log("list", response.data.data)
            }
            else if (response.status === 404) {
                setErrorSnackbarOpen(true)
                setSnackbarErrorMessage(response.data.message);
                setClients([])
            }
            else if (response.status === 400) {
                setErrorSnackbarOpen(true);
                setSnackbarErrorMessage(response.data.message)
                setClients([])
            }
            else {
                setErrorSnackbarOpen(true);
                setSnackbarErrorMessage("Unable to fetch details, please try again")
                setClients([])
            }
        }
        catch (error) {
            console.error("Error in fetching the data", error)
        }
    }
    useEffect(() => {
        if (clients.length > 0 && !selectedClient) {
            const firstClientId = clients[0].companyId;
            setSelectedClient(firstClientId);
        }
    }, [clients, selectedClient]);

    const handleYearChange = (e) => {
        setSelectedYear(e.target.value);
    };

    const handleQuarterChange = (e) => {
        setSelectedQuarter(e.target.value);
    };

    // Data for Doughnut Chart

    const overallAccepted = yearlyData ? parseFloat(yearlyData.overallYearlyAcceptedAvg) : 0;
    const overallRejected = yearlyData ? parseFloat(yearlyData.overallYearlyRejectedAvg) : 0;
    const overallUnderReview = yearlyData ? parseFloat(yearlyData.overallyearlyUnderReviewAvg) : 0;
    const total = overallAccepted + overallRejected + overallUnderReview;


    const remainingPercentage = (100 - (parseFloat(overallAccepted) + parseFloat(overallRejected) + parseFloat(overallUnderReview))).toFixed(2);

    const doughnutData = {
        labels: ['Accepted', 'Rejected', 'UnderReview', 'Not Uploaded'],
        datasets: [
            {
                data: [overallAccepted, overallRejected, overallUnderReview, remainingPercentage],
                backgroundColor: ['#50c878', '#B22222', '#EFCC00', 'lightgray'],  // Green for accepted, red for rejected
                borderWidth: 0,


            },
        ],
    };
    const chunkData = (data, chunkSize) => {
        let result = [];
        for (let i = 0; i < data.length; i += chunkSize) {
            result.push(data.slice(i, i + chunkSize));
        }
        return result;
    };

    // Data for Bar Chart
    let clientLabels = [];
    let combinedData = [];

    if (yearlyData && yearlyData.vendorAverages) {
        for (let i = 0; i < yearlyData.vendorAverages.length; i++) {
            const client = yearlyData.vendorAverages[i];
            const clientName = clients.find(c => c.companyId === client.companyId)?.clientName || '';

            clientLabels.push(clientName.slice(0, 5)); // Vendor names for X-axis
            // Combine the accepted and rejected data into one (you can sum or average them)
            const combinedValue = client.yearlyAcceptedAverage + client.yearlyRejectedAverage;
            combinedData.push(combinedValue);
        }
    }
    const chunkedVendorLabels = chunkData(clientLabels, 12); // Chunk the labels
    const chunkedCombinedData = chunkData(combinedData, 10);



    const getQuarterOrHalfData = () => {
        if (yearlyData && yearlyData.vendorAverages) {
            return yearlyData.vendorAverages.map(client => {
                switch (selectedQuarter) {
                    case 'Q1':
                        return client.Q1AcceptedAvg;
                    case 'Q2':
                        return client.Q2AcceptedAvg;
                    case 'Q3':
                        return client.Q3AcceptedAvg;
                    case 'Q4':
                        return client.Q4AcceptedAvg;
                    // case 'H1':
                    //     return client.H1AcceptedAvg;
                    // case 'H2':
                    //     return client.H2AcceptedAvg;
                    case 'Yearly':
                        return client.yearlyAcceptedAverage;
                    default:
                        return 0;
                }
            });
        }
        return [];
    };

    const getQuarterOrHalfDataRejected = () => {
        if (yearlyData && yearlyData.vendorAverages) {
            return yearlyData.vendorAverages.map(client => {
                switch (selectedQuarter) {
                    case 'Q1':
                        return client.Q1RejectedAvg;
                    case 'Q2':
                        return client.Q2RejectedAvg;
                    case 'Q3':
                        return client.Q3RejectedAvg;
                    case 'Q4':
                        return client.Q4RejectedAvg;
                    // case 'H1':
                    //     return client.H1RejectedAvg;
                    // case 'H2':
                    //     return client.H2RejectedAvg;
                    case 'Yearly':
                        return client.yearlyRejectedAverage;
                    default:
                        return 0;
                }
            });
        }
        return [];
    };
    const getQuarterOrHalfDataUnderReview = () => {
        if (yearlyData && yearlyData.vendorAverages) {
            return yearlyData.vendorAverages.map(client => {
                switch (selectedQuarter) {
                    case 'Q1':
                        return client.Q1UnderReviewAvg;
                    case 'Q2':
                        return client.Q2UnderReviewAvg;
                    case 'Q3':
                        return client.Q3UnderReviewAvg;
                    case 'Q4':
                        return client.Q4UnderReviewAvg;
                    // case 'H1':
                    //     return client.H1RejectedAvg;
                    // case 'H2':
                    //     return client.H2RejectedAvg;
                    case 'Yearly':
                        return client.YearlyUnderReviewAvg;
                    default:
                        return 0;
                }
            });
        }
        return [];
    };

    const acceptedQuarterData = getQuarterOrHalfData();
    const rejectedQuarterData = getQuarterOrHalfDataRejected();
    const underReviewQuarterData = getQuarterOrHalfDataUnderReview();

    return (
        <>
            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                severity="success"
                open={snackbarOpen}
                autoHideDuration={2000}
                onClose={() => setSnackbarOpen(false)}
                sx={{ marginTop: '2.9%', marginRight: '7%' }}
            >
                <SnackbarContent style={{ backgroundColor: "green" }} message={snackbarMessage} />
            </Snackbar>
            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                severity="error"
                open={errorSnackbarOpen}
                autoHideDuration={2000}
                sx={{ marginTop: '2.9%', marginRight: '7%' }}
                onClose={() => setErrorSnackbarOpen(false)}
            >
                <SnackbarContent style={{ backgroundColor: "red" }} message={snackbarErrorMessage} />
            </Snackbar>
            <div>
            {loading ? (
                  <div className="d-flex flex-row align-items-center justify-content-center" style={{ marginTop: '80px' }}>
                  <h3>Loading</h3>
         <div className="spinner-grow text-danger" style={{ width: '1rem', height: '1rem' ,marginLeft:'10px'}} role="status"></div> 
         <div className="spinner-grow text-danger" style={{ width: '1rem', height: '1rem' ,marginLeft:'10px'}} role="status"></div>
         <div className="spinner-grow text-danger" style={{ width: '1rem', height: '1rem' ,marginLeft:'10px'}} role="status"></div>
         
         </div>
              ) : 




                yearlyData && yearlyData.vendorAverages ? (
                    <section className="m-4 d-flex justify-content-around">


                        <div className="d-grid justify-content-center mt-5">
                        <div style={{
                                width: '120px',
                                height: '80px',

                                backgroundColor: '#FBC02D',
                                color: '#000',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                letterSpacing: '1px',
                                textAlign: 'center'
                            }}>
                                <div>Year</div>
                                <div style={{ fontSize: '25px', fontWeight: 'bolder' }}>{selectedYear}</div>
                            </div>
                            <div style={{
                                width: '120px',
                                height: '80px',

                                backgroundColor: '#66BB6A',
                                color: 'white',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                letterSpacing: '1px',
                                textAlign: 'center'
                            }}>
                                <div>Establishment</div>
                                <div style={{ fontSize: '25px', fontWeight: 'bolder' }}>{clients.length}</div>
                            </div>
                            <div style={{
                                width: '120px',
                                height: '80px',

                                backgroundColor: '#FBC02D',
                                color: '#000',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                letterSpacing: '1px',
                                textAlign: 'center'
                            }}>
                                <div>Vendors</div>
                                <div style={{ fontSize: '25px', fontWeight: 'bolder' }}>{data.NoOfVendors}</div>
                            </div>
                            <div style={{
                                width: '120px',
                                height: '80px',

                                backgroundColor: '#66BB6A',
                                color: 'white',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                letterSpacing: '1px',
                                textAlign: 'center'
                            }}>
                                <div>Employees</div>
                                <div style={{ fontSize: '25px', fontWeight: 'bolder' }}>{data.NoOfEmployees}</div>
                            </div>

                         
</div>



                        {/* Dognut section */}
                        <div style={{ border: '1px solid lightgray' }}>
                            <div className="bg-dark d-flex p-3" >
                                <h6 className="text-light">Establishment Average Yearly Compliance</h6>

                                <select value={selectedYear} onChange={handleYearChange} className="mx-3 year-dropdown text-dark bg-light" style={{ cursor: 'pointer' }}>
                                    {Array.from({ length: currentYear - 2020 + 1 }, (_, i) => 2020 + i).map((year) => (
                                        <option key={year} value={year}>
                                            {year}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '300px' }}>
                                <div style={{ height: '220px', width: '220px' }}>
                                    <Doughnut
                                        data={doughnutData}
                                        options={{
                                            cutout: '30%',
                                            backgroundColor: 'black',
                                            responsive: true,
                                            plugins: {
                                                legend: {
                                                    display: false,

                                                },
                                                tooltip: {
                                                    callbacks: {
                                                        label: function (context) {
                                                            let percentage;
                                                            if (context.label === 'Accepted') {
                                                                percentage = overallAccepted;
                                                                return `Accepted: ${percentage}%`;
                                                            } else if (context.label === 'Rejected') {
                                                                percentage = overallRejected;
                                                                return `Rejected: ${percentage}%`;
                                                            } else if (context.label === 'UnderReview') {
                                                                percentage = overallUnderReview;
                                                                return `UnderReview: ${percentage}%`;
                                                            } else if (context.label === 'Not Uploaded') {
                                                                percentage = remainingPercentage;
                                                                return `Not Uploaded: ${percentage}%`;
                                                            }
                                                        },
                                                    },
                                                },
                                                datalabels: {
                                                    display: true,
                                                    color: 'white',
                                                    align: 'center',
                                                    anchor: 'center',
                                                    font: {
                                                        size: 13,
                                                    },
                                                    formatter: function (value) {
                                                        return value === 0 ? '' : `${value}%`;
                                                    },
                                                    position: 'outside',
                                                    offset: 15,
                                                },
                                            },
                                        }}
                                    />
                                </div>
                            </div>
                        </div>


                        {/* Site wise section */}
                        <div className='w-50' style={{ border: '1px solid lightgray' }}>
                            <div className='bg-dark p-3 d-flex text-center justify-content-between'>
                                <h6 className="text-light">Site Wise Average Compliance</h6>
                                <select
                                    value={selectedQuarter}
                                    onChange={handleQuarterChange}
                                    className="quarter-dropdown text-dark bg-light mx-3"
                                    style={{ cursor: 'pointer' }}
                                >
                                    {['Yearly', 'Q1', 'Q2', 'Q3', 'Q4'].map((quarter) => (
                                        <option key={quarter} value={quarter}>
                                            {quarter}
                                        </option>
                                    ))}
                                </select>
                            </div>



                            {chunkedVendorLabels.map((chunk, index) => {
                                return (
                                    <Bar
                                        className="w-100"
                                        key={index}

                                        data={{
                                            labels: chunk, // Vendor names for the X-axis
                                            datasets: [
                                                {
                                                    label: 'Accepted',
                                                    data: acceptedQuarterData,  // Data for "Accepted"
                                                    backgroundColor: '#3CB371', // Green color for "Accepted"
                                                    borderColor: '#50c878',
                                                    borderRadius: 0, // No border radius
                                                    borderWidth: 0,
                                                    barThickness: 25,
                                                    stack: 'stack1'// Set bar thickness for accepted bars

                                                },

                                                {
                                                    label: 'UnderReview',
                                                    data: underReviewQuarterData,  // Data for "Accepted"
                                                    backgroundColor: '#EFCC00', // Green color for "Accepted"
                                                    borderColor: '#EFCC00',
                                                    borderRadius: 0, // No border radius
                                                    borderWidth: 0,
                                                    barThickness: 25,
                                                    stack: 'stack1' // Set bar thickness for accepted bars

                                                },
                                                {
                                                    label: 'Rejected',
                                                    data: rejectedQuarterData,  // Data for "Rejected"
                                                    backgroundColor: '#B22222', // Red color for "Rejected"
                                                    borderColor: '#B22222',
                                                    borderRadius: 0, // No border radius
                                                    borderWidth: 0,
                                                    barThickness: 25,
                                                    stack: 'stack1' // Set bar thickness for rejected bars

                                                },
                                            ],
                                        }}
                                        options={{
                                            responsive: true,
                                            scales: {
                                                x: {
                                                    grid: {
                                                        display: false, // Hide grid lines for X-axis
                                                    },
                                                    ticks: {
                                                        display: true,
                                                        color: 'gray',
                                                        font: {
                                                            size: 10,
                                                        },
                                                        maxRotation: 45,
                                                        minRotation: 30,
                                                    },
                                                },
                                                y: {
                                                    min: 0, // Start the Y-axis from 0%
                                                    grid: {
                                                        display: false, // Show grid lines for Y-axis
                                                    },
                                                    ticks: {
                                                        display: false, // Show ticks on Y-axis
                                                        stepSize: 10, // Control the step size for ticks
                                                        callback: function (value) {
                                                            return value + '%'; // Format Y-axis ticks as percentage
                                                        },
                                                    },
                                                    stacked: true,
                                                },
                                            },
                                            plugins: {
                                                legend: {
                                                    display: false, // Disable the legend
                                                },
                                                title: {
                                                    display: true,
                                                },
                                                tooltip: {
                                                    callbacks: {
                                                        label: function (tooltipItem) {
                                                            const client = yearlyData.vendorAverages[tooltipItem.dataIndex];
                                                            const fullVendorName = clients.find(c => c.companyId === client.companyId)?.clientName || '';
                                                            const acceptedValue = acceptedQuarterData[tooltipItem.dataIndex]; // Correct data access for Accepted
                                                            const rejectedValue = rejectedQuarterData[tooltipItem.dataIndex]; // Correct data access for Rejected
                                                            const underReviewValue = underReviewQuarterData[tooltipItem.dataIndex]
                                                            if (tooltipItem.datasetIndex === 0) {
                                                                // Dataset 0 represents Accepted
                                                                return `${fullVendorName}: Accepted ${acceptedValue}%`;
                                                            } else if (tooltipItem.datasetIndex === 1) {
                                                                // Dataset 1 represents Rejected
                                                                return `${fullVendorName}: UnderReview ${underReviewValue}%`;
                                                            }
                                                            else {
                                                                return `${fullVendorName}: Rejected ${rejectedValue}%`;
                                                            }
                                                        }
                                                    },
                                                },
                                                datalabels: {
                                                    display: true, // Enable data labels
                                                    color: 'white', // Text color for the percentage labels
                                                    align: 'center', // Align the label at the center of the bar
                                                    font: {
                                                        size: 10, // Font size for the percentage labels
                                                    },
                                                    rotation: -50,
                                                    formatter: function (value, context) {
                                                        let roundedValue;
                                                        if (context.datasetIndex === 0) {
                                                            // For Accepted bars, show the accepted percentage
                                                            const acceptedValue = acceptedQuarterData[context.dataIndex];
                                                            roundedValue = acceptedValue;
                                                            if (roundedValue != 0)
                                                                return `${roundedValue}%`;
                                                        } else if (context.datasetIndex === 2) {
                                                            // For Rejected bars, show the rejected percentage
                                                            const rejectedValue = rejectedQuarterData[context.dataIndex];
                                                            roundedValue = rejectedValue;
                                                            if (roundedValue != 0) {// Show percentage for the "Rejected" bar
                                                                return `${roundedValue}%`
                                                            }
                                                        }
                                                        else if (context.datasetIndex === 1) {
                                                            // For Rejected bars, show the rejected percentage
                                                            const underReviewValue = underReviewQuarterData[context.dataIndex];
                                                            roundedValue = underReviewValue;
                                                            if (roundedValue != 0) {// Show percentage for the "Rejected" bar
                                                                return `${roundedValue}%`
                                                            }
                                                        }
                                                        return ''; // Show percentage for the "Rejected" bar

                                                    },
                                                },
                                            },
                                        }}
                                    />
                                )
                            })}

                        </div>


                    </section>
                ) : (
                    <div className="text-center text-danger p-5">
                        Monthly Data not created for the selected Year!!
                        <select value={selectedYear} onChange={handleYearChange} className="mx-3 year-dropdown text-light bg-dark" style={{ cursor: 'pointer', border: '1px solid lightgray' }}>
                            {Array.from({ length: currentYear - 2020 + 1 }, (_, i) => 2020 + i).map((year) => (
                                <option key={year} value={year}>
                                    {year}
                                </option>
                            ))}
                        </select>
                    </div>

                )

                }



            </div>
        </>
    );
};

export default AvrgMonthlyCompliance
